import React from 'react';
import './FlipText.css';

export default function FlipText({ text = '', className = '', frontColor = '#000', backColor = '#fff' }) {
  return (
    <span
      className={`flip-word ${className}`}
      aria-hidden="false"
      style={{ ['--front-color']: frontColor, ['--back-color']: backColor }}
    >
      {Array.from(text).map((ch, i) => (
        <span key={i} className="char-wrap" aria-hidden="true">
          <span className="char front">{ch}</span>
          <span className="char back">{ch}</span>
        </span>
      ))}
    </span>
  );
}
